import type React from 'react'

import { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { MesAnoInput } from '@/components/form/input/date-mask-input'

interface AddMonthDialogProps {
  isOpen: boolean
  onClose: () => void
  onAdd: (month: string) => void
}

export function AddMonthDialog({ isOpen, onClose, onAdd }: AddMonthDialogProps) {
  const [month, setMonth] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (month.trim()) {
      onAdd(month.trim()) 
      setMonth('')
      onClose()
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Adicionar Mês de Competência</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="month">Mês de Competência</Label>

            {/* AQUI: MesAnoInput com VALUE e ONCHANGE */}
            <MesAnoInput
              value={month}              // MMYYYY
              onChange={setMonth}        // atualiza estado
            />
          </div>

          <div className="flex justify-end space-x-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit">Adicionar</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
